(function () {
    'use strict';

    // How It Works "Design your sticker" demo. The form's hx-get re-renders the preview on `input` (debounced) and on
    // `designer-change`; this file only keeps the non-form bits in step: the body-colour hidden input, the shade row
    // for the chosen colour, trade message suggestions, the character counter and the brand-colour picker.
    const form = document.getElementById('sticker-designer');
    if (!form) return;

    // Arriving from Van Health's "Customise this sticker" (#sticker-designer): the browser scrolls as soon as the
    // anchor exists, then the images and fonts above it load and push the designer down the page. Scroll again
    // once everything has loaded, so the visitor lands on the designer and not on the section before it.
    if (location.hash === '#sticker-designer') {
        window.addEventListener('load', function () {
            form.scrollIntoView({ block: 'start' });
        }, { once: true });
    }

    const bodyHex     = document.getElementById('designer-body-hex');
    const shadesWrap  = document.getElementById('designer-shades-wrap');
    const shades      = document.getElementById('designer-shades');
    const message     = document.getElementById('designer-message');
    const count       = document.getElementById('designer-message-count');
    const trade       = document.getElementById('designer-trade');
    const suggestions = document.getElementById('designer-suggestions');
    const brandWrap   = document.getElementById('designer-brand-wrap');

    const GENERAL = ['SCAN ME', 'GET A QUOTE', 'BOOK NOW', 'CALL US', 'SEE OUR WORK'];
    const CHIP    = 'rounded-full border border-gray-300 bg-white px-2.5 py-1 text-[11px] font-semibold text-gray-700 transition hover:border-accent hover:text-accent';
    const CHIP_ON = 'rounded-full border border-accent bg-accent px-2.5 py-1 text-[11px] font-semibold text-white transition hover:bg-accent/80';
    const trades  = (() => {
        try { return JSON.parse((trade && trade.dataset.trades) || '[]'); } catch { return []; }
    })();

    function changed() {
        form.dispatchEvent(new CustomEvent('designer-change'));
    }

    // A <form> without an action would submit to the page on Enter — the preview is live, so just swallow it.
    form.addEventListener('submit', e => e.preventDefault());

    // ── Van colour + shade ──────────────────────────────────────────────────────
    function renderShades(radio) {
        const list = (radio.dataset.shades || '').split(',').filter(Boolean);
        shades.replaceChildren();
        shadesWrap.hidden = list.length === 0;

        list.forEach((hex, i) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            // Sized by its grid cell (8 across, one row) so the shades fit any phone without wrapping.
            btn.className = 'shade-dot w-full aspect-square rounded-full border-2 border-white focus:outline-none focus-visible:ring-2 focus-visible:ring-accent';
            btn.style.backgroundColor = hex;
            btn.dataset.hex = hex;
            btn.setAttribute('aria-label', 'Shade ' + (i + 1));
            btn.setAttribute('aria-pressed', 'false');
            shades.appendChild(btn);
        });
    }

    function markShade(hex) {
        // The chosen shade is marked by .shade-dot[aria-pressed] in CSS — a black ring, never a blue one.
        shades.querySelectorAll('button').forEach(b => {
            b.setAttribute('aria-pressed', b.dataset.hex === hex ? 'true' : 'false');
        });
    }

    form.querySelectorAll('input[name="colour"]').forEach(radio => {
        radio.addEventListener('change', () => {
            // Runs before the debounced hx-get fires, so the request carries the new body colour.
            bodyHex.value = radio.dataset.hex;
            renderShades(radio);
        });
    });

    shades.addEventListener('click', e => {
        const btn = e.target.closest('button[data-hex]');
        if (!btn) return;
        bodyHex.value = btn.dataset.hex;
        markShade(btn.dataset.hex);
        changed();
    });

    const initial = form.querySelector('input[name="colour"]:checked');
    if (initial) {
        renderShades(initial);
        markShade(bodyHex.value);   // the starting shade reads as chosen, not as an untouched row
    }

    // ── Message ─────────────────────────────────────────────────────────────────
    function updateCount() {
        if (count) count.textContent = String(message.value.length);
    }

    function renderSuggestions(list) {
        suggestions.replaceChildren();
        list.forEach(text => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.dataset.message = text;
            btn.textContent = text;
            btn.className = CHIP;
            suggestions.appendChild(btn);
        });
        markSuggestion();
    }

    // The chip matching the current message shows the sign-up "selected" state (solid accent).
    function markSuggestion() {
        const current = message.value.trim().toUpperCase();
        suggestions.querySelectorAll('button[data-message]').forEach(b => {
            const on = b.dataset.message === current;
            b.className = on ? CHIP_ON : CHIP;
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
    }

    message.addEventListener('input', () => { updateCount(); markSuggestion(); });

    suggestions.addEventListener('click', e => {
        const btn = e.target.closest('button[data-message]');
        if (!btn) return;
        message.value = btn.dataset.message.slice(0, message.maxLength > 0 ? message.maxLength : 22);
        updateCount();
        markSuggestion();
        changed();
    });

    if (trade) {
        trade.addEventListener('input', e => e.stopPropagation());   // choosing a trade alone doesn't change the sticker
        trade.addEventListener('change', () => {
            const match = trades.find(t => t.name === trade.value);
            const tradeMessages = match ? match.messages : [];
            renderSuggestions([...new Set([...tradeMessages, ...GENERAL])]);
        });
    }

    renderSuggestions(GENERAL);
    updateCount();

    // ── Style ───────────────────────────────────────────────────────────────────
    function syncStyle() {
        const style = form.querySelector('input[name="Style"]:checked');
        brandWrap.hidden = !style || style.value !== 'Branded';
    }

    form.querySelectorAll('input[name="Style"]').forEach(r => r.addEventListener('change', syncStyle));
    syncStyle();
}());
